import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { selectIsLoggedIn, selectAccount } from '../../auth/ducks';
import { Pomoc } from '..';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createQuestionActions } from '../../help-management/ducks'
import { apiCallIds } from '../../help-management/api'
import { selectIsInProgress } from '../../spinner/ducks';
import Spin from 'antd/lib/spin';



const mapStateToProps = state => ({
    isLoggedIn: selectIsLoggedIn(state),
    account: selectAccount(state),
    submittingQuestion: selectIsInProgress(state, apiCallIds.CREATE_QUESTION)
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
      {
        createQuestion: createQuestionActions.request,

      },
      dispatch
    )
});

@connect(mapStateToProps, mapDispatchToProps)
export default class PomocContainer extends Component {
  

  static propTypes = {
    actions: PropTypes.object.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    account: PropTypes.object,
    submittingQuestion: PropTypes.bool.isRequired,
  };

  onSubmit = helpData => {
    const { isLoggedIn, account } = this.props
    if(isLoggedIn){
      helpData.email = account.email
      helpData.name = account.nameFirst + ' ' + account.nameLast
      helpData.AccountId = account.id
    }
    this.props.actions.createQuestion( helpData )


  }
    
  render(){
      const { submittingQuestion, isLoggedIn, account } = this.props

      return(
        <Spin spinning={submittingQuestion}>
          <Pomoc 
            isLoggedIn={isLoggedIn}
            onSubmit={this.onSubmit}
            account={account}
          />
        </Spin>
          
      )
  }
}


// WEBPACK FOOTER //
// ./src/features/pages/containers/PomocContainer.js